import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'm-message-model',
  templateUrl: './message-model.component.html',
  styleUrls: ['./message-model.component.scss']
})
export class MessageModelComponent implements OnInit {

  type: 'primary | accent | warn';
  duration: number = 0;
  message: string = '';
  showCloseButton: boolean = true;
  isLoading: boolean = false;
  spinnerSize: number = 40;

  constructor(public dialogRef: MatDialogRef<MessageModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = data.type || 'primary';
    this.showCloseButton = data.showCloseButton !== false;
    this.message = data.message || '';
    this.isLoading = data.isLoading || false;
    this.spinnerSize = data.spinnerSize || 40;
  }

  ngOnInit() {
  }

  closeAlert() {
    this.dialogRef.close();
  }
}
